import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../../../components/global/Button';
import PinField from '../../../../../../components/global/PinField';
import Alert from '../../../../../../components/global/Alert';
import CustomControl from '../../../../../../components/global/CustomControl';
import { EVENTS } from '../../../../../../services/gtag/constants';
import useGtagManualTracking from '../../../../../../services/gtag/useGtagManualTracking';

const propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.shape({
    phone_number: PropTypes.string.isRequired,
  }).isRequired,
  onPinCodeResend: PropTypes.func.isRequired,
  onEmailSignup: PropTypes.func.isRequired,
  requireHumanInput: PropTypes.bool,
  blockLogin: PropTypes.bool,
};

const INACTIVITY_TIMEOUT = 20000; // 20s

const RegistrationPhoneVerify = ({
  className,
  loading,
  handleSubmit,
  handleChange,
  onPinCodeResend,
  onEmailSignup,
  values,
  requireHumanInput,
  blockLogin,
}) => {
  const { onTrackEvent } = useGtagManualTracking();
  const [showEmailSignupPrompt, setShowEmailSignupPrompt] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowEmailSignupPrompt(true);
    }, INACTIVITY_TIMEOUT);
  }, []);

  useEffect(() => {
    handleChange({
      target: {
        name: 'force_allow_action',
        value: false,
      },
    });
  }, []);

  const classes = classNames({
    [className]: !!className,
  });
  const isValid = values.code?.length === 4;

  return (
    <div className={classes}>
      <form
        onSubmit={e => {
          onTrackEvent({
            event: EVENTS.CLICK_VERIFY_PIN_CODE,
            data: {
              page_title: 'Complete Consumer Pin Auth',
            },
          });

          handleSubmit(e);
        }}
      >
        <div className="mb-3">
          <PinField
            className="registration-pin-field registration-pin-input"
            onComplete={value => {
              handleChange({
                target: {
                  name: 'code',
                  value,
                },
              });
            }}
            onChange={value => {
              handleChange({
                target: {
                  name: 'code',
                  value,
                },
              });
            }}
          />
        </div>

        <div>
          <Button
            type="submit"
            disabled={loading || !isValid}
            loading={loading}
            className="d-block mt-2"
          >
            {loading ? 'Processing...' : 'Verify Pin Code'}
          </Button>

          {requireHumanInput && (
            <div className="mt-2">
              <CustomControl
                type="checkbox"
                label="I'm not a robot"
                checked={values.force_allow_action}
                onChange={() =>
                  handleChange({
                    target: {
                      name: 'force_allow_action',
                      value: !values.force_allow_action,
                    },
                  })
                }
              />
            </div>
          )}

          <Button
            type="button"
            btnStyle="link"
            disabled={
              loading ||
              blockLogin ||
              (requireHumanInput && !values.force_allow_action)
            }
            loading={loading}
            className="d-block mt-2"
            onClick={() => onPinCodeResend(values)}
          >
            Re&ndash;send code
          </Button>
        </div>
        {showEmailSignupPrompt && (
          <Alert type="info" className="d-flex align-items-baseline mt-2">
            Not receiving the SMS?{' '}
            <Button btnStyle="link" className="ml-1" onClick={onEmailSignup}>
              Receive a PIN via email instead
            </Button>
          </Alert>
        )}
      </form>
    </div>
  );
};

RegistrationPhoneVerify.propTypes = propTypes;

export default RegistrationPhoneVerify;
